import React from "react";
import styled from "styled-components";

const CustomCardDiv = styled.div`
  width: 100%;
  height: auto;
  position:relative;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 21px 0 rgba(51, 51, 51, 0.1);
  background-color: white;
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.2);
`;

const CustomCard = ({ children ,  }) => {
  return (
    <div className=" width-100">
      <CustomCardDiv>{children}</CustomCardDiv>
    </div>
  );
};

export default CustomCard;
